// 1. React
import { forwardRef, memo, useImperativeHandle, useRef } from "react";

// 2. UI Components
import { Tabs } from "ui/components/Tabs";

// 3. Types
import { VehicleExpenseCardProps, VehicleExpenseRef } from "./types";

// 4. Local Components
import VehicleExpenseSearchCard from "./components/VehicleExpenseSearchCard/VehicleExpenseSearchCard";
import { VehicleExpenseSearchRef } from "./components/VehicleExpenseSearchCard/types";
import VehicleExpenseStatsCard from "./components/VehicleExpenseStatsCard/VehicleExpenseStatsCard";

const VehicleExpenseCard = forwardRef<
  VehicleExpenseRef,
  VehicleExpenseCardProps
>((props, ref) => {

  const { fleetVehicleDetail } = props;

  const searchRef = useRef<VehicleExpenseSearchRef>(null);

  useImperativeHandle(ref, () => ({
    openAddNew: () => searchRef.current?.openAddNew(),
  }));

  if (!fleetVehicleDetail.id) return <></>;

  return (
    <Tabs
      tabs={[
        {
          label: "Pretraga",
          content: (
            <div>
              <VehicleExpenseSearchCard
                ref={searchRef}
                fleetVehicleDetail={fleetVehicleDetail}
              />
            </div>
          ),
        },
        {
          label: "Statistika",
          content: (
            <div>
              <VehicleExpenseStatsCard fleetVehicleDetail={fleetVehicleDetail} />
            </div>
          ),
        },
      ]}
    />
  );
});

export default memo(VehicleExpenseCard);
